import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

// Simple Markdown icon: rounded rectangle with an 'M' inside
export const MarkdownIcon = React.memo(function MarkdownIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Container */}
      <rect x="0.5" y="2.5" width="14" height="11" rx="2" stroke={color} />
      {/* M letter */}
      <path
        d="M3.5 10.5V5.5L6 8.5L8.5 5.5V10.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Tiny down arrow on the right side (outlined with stem) */}
      <path d="M11.5 5.5V10.5" stroke={color} strokeLinecap="round" />
      <path
        d="M10.5 9.5L11.5 10.5L12.5 9.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
